import React from "react";

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import LazyLoad from 'react-lazyload';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/Rewards/Rewards.css";


const rewardMiniCard = {
     margin: "15px",
     borderRadius: "15px",
     boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
     height: "300px"
}
const rewardMiniCardImg = {
     width: "150px", height: "150px",
     boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
     border: "2px solid #8d8d8d",
     borderRadius: "50%"
}
const rewardMiniCardText = {
     fontFamily: "IranSans",
     fontSize: ".9em",
     color: "#186491",
     textAlign: "center",
     direction: "rtl"
}
const rewardMiniCardTextTablet = {
     fontFamily: "IranSans",
     fontSize: ".85em",
     color: "#186491",
     textAlign: "center",
     direction: "rtl"
}
const rewardMiniCardMobile = {
     fontFamily: "IranSans",
     fontSize: ".8em",
     color: "#186491",
     textAlign: "center",
     direction: "rtl"
}

const RewardsCard = props => {
     return props.size === "laptopdesktop" ? (
          <div>
               <Card style={rewardMiniCard}>
                    <LazyLoad>
                    <Center>
                         
                         <img
                              style={rewardMiniCardImg}
                              src={props.img} />
                    </Center>

                    </LazyLoad>
                    <Margin top={2}></Margin>
                    <Center>
                         <p style={rewardMiniCardText}>
                              {props.description}
                         </p>
                    </Center>
               </Card>
          </div>
     ) : props.size === "tablet" ? (
          <div>
               <Card style={rewardMiniCard}>
                         <LazyLoad>
                              <Center>

                                   <img
                                        style={rewardMiniCardImg}
                                        src={props.img} />
                              </Center>

                         </LazyLoad>
                    <Margin top={2}></Margin>
                    <Center>
                         <p style={rewardMiniCardTextTablet}>
                              {props.description}
                         </p>
                    </Center>
               </Card>
          </div>

     ) : (
          <div>
               <Card style={rewardMiniCard}>
                              <LazyLoad>
                                   <Center>

                                        <img
                                             style={rewardMiniCardImg}
                                             src={props.img} />
                                   </Center>

                              </LazyLoad>
                    <Margin top={2}></Margin>
                    <Center>
                         <p style={rewardMiniCardMobile}>
                              {props.description}                             
                         </p>
                    </Center>
               </Card>
          </div>
     );
};

export default RewardsCard;
